import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss';
import DisplayTransition from "../../../../../../components/transitions/display-transition";
import BlackMask from "../../../../../../components/mask/index";
import { Iconfont } from "../../../../../../../components/icon/iconfont";


const ProductTransitonModal = props =>{
    useStyles(classes);
    const { show, onClose } = props;

    return <React.Fragment>
            <DisplayTransition in={show} className={`${classes.ProductTransitonModal} ${props?.className?props.className:""}`}>
                <div>
                    <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
                    {
                        props?.children
                    }
                </div>
            </DisplayTransition>

        {
            show && <BlackMask onClick={onClose} />
        }
    </React.Fragment>
    
}

export default ProductTransitonModal;